import {
  LEGAL_CONTACT_EMAIL,
  LEGAL_ENTITY_NAME,
  LEGAL_MIN_AGE,
} from '../config/legal';
import type { LegalSection } from './legalTypes';

export const privacyPolicySections: LegalSection[] = [
  {
    title: '1. Who we are',
    paragraphs: [
      `${LEGAL_ENTITY_NAME} ("we", "us", "our") operates the TrackiAI website and related services. For questions about this policy or your personal data, contact us at ${LEGAL_CONTACT_EMAIL}.`,
    ],
  },
  {
    title: '2. Scope',
    paragraphs: [
      'This Privacy Policy explains how we collect, use, disclose, and protect personal data when you use TrackiAI. It is intended to align with the Singapore Personal Data Protection Act 2012 (PDPA). If you access our services from the European Economic Area or UK, additional rights may apply as described below.',
    ],
  },
  {
    id: 'cookies',
    title: '3. Information we collect',
    paragraphs: ['We may collect the following categories of personal data:'],
    bullets: [
      'Account data: name, email address, password (stored by our authentication provider), date of birth, and role-related settings.',
      'Athletics data: competition results, performance marks, club affiliations, and requests to link your account to existing results.',
      'Usage data: pages visited, features used, device/browser type, and approximate location derived from IP address.',
      'Communications: messages you send via our contact form or support channels.',
      'Payment data (if applicable): billing is processed by Stripe; we do not store full card numbers.',
      'Cookies and similar technologies: see the Cookies section below.',
    ],
  },
  {
    title: '4. How we use your data',
    paragraphs: ['We use personal data to:'],
    bullets: [
      'Provide and secure your account and the TrackiAI platform.',
      'Display athletics results, analytics, and live competition information.',
      'Process registration, club membership requests, and admin review of result-tagging requests.',
      'Operate AI-assisted features (e.g. TrackiAI) using your queries and permitted data.',
      'Respond to enquiries and improve our services.',
      'Comply with law and enforce our Terms of Service.',
    ],
  },
  {
    title: '5. Legal bases (EEA/UK visitors)',
    paragraphs: [
      'Where GDPR applies, we rely on: performance of a contract (account and core services); legitimate interests (security, analytics, product improvement); and consent where required (e.g. non-essential cookies). You may withdraw consent at any time without affecting lawfulness of processing before withdrawal.',
    ],
  },
  {
    title: '6. Cookies',
    paragraphs: [
      'Essential cookies and local storage are used for authentication (Firebase) and to remember your cookie preferences. Analytics cookies (Google Firebase Analytics) are only activated if you choose "Accept all" on our cookie banner. You can change your choice at any time via the cookie settings link in the site footer.',
    ],
  },
  {
    title: '7. Sharing and processors',
    paragraphs: [
      'We use trusted service providers who process data on our behalf, including Google (Firebase Authentication and Analytics), cloud hosting, and payment processors when billing is enabled. These providers may process data outside Singapore. We require appropriate safeguards where required by law.',
    ],
  },
  {
    title: '8. Retention',
    paragraphs: [
      'We retain personal data for as long as your account is active and as needed to provide services, resolve disputes, and meet legal obligations. Contact form submissions are retained for a reasonable period to handle your enquiry.',
    ],
  },
  {
    title: '9. Your rights',
    paragraphs: [
      'Depending on applicable law, you may have the right to access, correct, or delete your data; withdraw consent; object to or restrict processing; and lodge a complaint with the Personal Data Protection Commission (Singapore) or your local authority. Contact us at ' +
        LEGAL_CONTACT_EMAIL +
        ' to exercise these rights.',
    ],
  },
  {
    title: '10. Age',
    paragraphs: [
      `TrackiAI is not intended for children under ${LEGAL_MIN_AGE}. By registering you confirm you are at least ${LEGAL_MIN_AGE} years old. Users under 18 should use the service with parental or guardian guidance.`,
    ],
  },
  {
    title: '11. Security',
    paragraphs: [
      'We implement reasonable technical and organisational measures to protect personal data. No method of transmission over the Internet is completely secure.',
    ],
  },
  {
    title: '12. Changes',
    paragraphs: [
      'We may update this policy from time to time. We will post the revised version on this page with an updated date.',
    ],
  },
];
